import React, { Component } from 'react';
import { Field } from 'redux-form';
import classnames from 'classnames';

const fields = {
  InputText: 'text',
  InputPassword: 'password',
}

const inputs = {};
Object.keys(fields).map(field => {
  inputs[field] = (props) => (<Field component={Input} type={fields[field]} {...props}/>);
})

function Checkbox(props) {
  return (<Field component={RadioComponent} type="checkbox" {...props}/>);
}

function Input({ input, className = '', label, children, icon, meta: { pristine, touched, error } , ...inputProps}) {
  const classNames = classnames('form-group', className, {
    'has-error': (!pristine || touched) && error,
    'has-icon': !!icon,
    'has-label': !!label,
  });

  return (
    <div className={classNames}>
      { icon && (<span className={`form-icon ${icon}`}/>)}
      { label && (<label>{label}</label>)}
      <input className="form-control" {...input} {...inputProps} />
      {children}
      {(!pristine || touched) && error && <div className="text-danger form-error small">{error}</div>}
    </div>
  );
}

function RadioComponent({ input, className = '', children, label, meta: { touched, error } , ...inputProps}) {
  return (
    <div className={classnames('checkbox', className, {'has-error': touched && error}) }>
      <label>
        <input {...input} {...inputProps} />
        {label}
      </label>
      {children}
      {touched && error && <div className="text-danger form-error small">{error}</div>}
    </div>
  );
}


module.exports = { ...inputs, Checkbox };



// WEBPACK FOOTER //
// ./components/forms/Inputs.js